import { useState } from "react";
import emailjs from "@emailjs/browser";

const Footer = ({ setDoc }) => {
  const pubUrl = process.env.PUBLIC_URL;

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: ""
  });

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_hzl4rxj",
        "template_kp0ryl9",
        e.target, // ✅ MUST be the form element
        "LT1bMQlUqxrsLhM-M"
      )
      .then(() => {
        alert("Message sent successfully!");
        setFormData({
          name: "",
          phone: "",
          email: "",
          message: ""
        });
      })
      .catch((error) => {
        console.error("EmailJS error:", error);
        alert("Failed to send message. Please try again.");
      });
  };

  return (
    <div className="footer">
      <div className="footer-split">
        <h3>Contact Us</h3>
        <div className="line-short black" />

        <form onSubmit={sendEmail}>
          <input
            type="text"
            name="name"
            placeholder="Name"
            value={formData.name}
            onChange={(e) =>
              setFormData({ ...formData, name: e.target.value })
            }
            required
          />

          <input
            type="text"
            name="phone"
            placeholder="Phone"
            value={formData.phone}
            onChange={(e) =>
              setFormData({ ...formData, phone: e.target.value })
            }
          />

          <input
            type="text"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={(e) =>
              setFormData({ ...formData, email: e.target.value })
            }
            required
          />

          <textarea
            name="message"
            placeholder="Message"
            value={formData.message}
            onChange={(e) =>
              setFormData({ ...formData, message: e.target.value })
            }
            required
          />

          <button type="submit">SEND MESSAGE</button>
        </form>
      </div>

      <div className="footer-split">
        <div className="social-banner">
          <img src={`${pubUrl}/icons/instagram.png`} alt="instagram" />
          <img src={`${pubUrl}/icons/nextdoor.png`} alt="nextdoor" />
          <img src={`${pubUrl}/icons/yelp.png`} alt="yelp" />
          <img src={`${pubUrl}/icons/facebook.png`} alt="facebook" />
        </div>

        <div className="footer-list">
          <img src={`${pubUrl}/logo.png`} alt="logo" />
          <p>(713) 385 2814</p>
          <p>james@lonestar-roofing.net</p>

          <p onClick={() => setDoc("Privacy Policy")}>Privacy Policy</p>
          <p onClick={() => setDoc("Terms of Service")}>Terms of Service</p>
          <p onClick={() => setDoc("Warranty Information")}>
            Warranty Information
          </p>

          <p>Lone Star Roofing ©2026</p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
